import * as React from 'react';
import { Product } from '../../components';
import { ProductProps } from './product-type';

import enhancer from './product-enhancer';
import styles from './product-page.module.css';

const productPage: React.FC<ProductProps> = React.memo(({ product, ...rest }: ProductProps) => {
    if (!product) {
        return <React.Fragment />;
    }

    const brandID = product.brand.id;

    return (
        <div className={styles.container}>
            <Product {...product} {...rest} id={brandID} />
        </div>
    );
});

export const ProductPage = enhancer(productPage);
